import { Controller } from "@hotwired/stimulus"
import ScrollMirror from 'scrollmirror'

export default class extends Controller {
  connect() {
    // new ScrollMirror(document.querySelectorAll(".comparable"));
  }
}